import React, { useEffect, useState } from "react";
import { getBuyerOverview } from "../../api/buyerOverview.api";

const BuyerOverview = () => {
  const [data, setData] = useState({
    total_rfqs: 0,
    pending_rfqs: 0,
    approved_rfqs: 0,
    rejected_rfqs: 0,
    saved_products: 0
  });

  useEffect(() => {
    getBuyerOverview().then(res => setData(res.data.data));
  }, []);

  const cards = [
    { label: "Active Inquiries", value: data.total_rfqs, icon: "📄" },
    { label: "Pending Quotes", value: data.pending_rfqs, icon: "💬" },
    { label: "Saved Products", value: data.saved_products, icon: "❤️" },
    { label: "RFQs Sent", value: data.total_rfqs, icon: "📈" }
  ];

  const cardStyle = { 
    backgroundColor: "#fff", 
    border: "1px solid #e5e7eb", 
    borderRadius: "8px", 
    padding: "clamp(15px, 3vw, 24px)", 
    height: "100%" 
  };

  return (
    <div className="row g-3 g-md-4">
      {cards.map((c, i) => (
        <div className="col-6 col-md-3" key={i}>
          <div style={cardStyle}>
            <div className="fs-4 mb-2 opacity-50">{c.icon}</div>
            <h2 className="fw-bold m-0" style={{ color: "#112347", fontSize: 'clamp(22px, 3vw, 28px)' }}>{c.value}</h2>
            <p className="text-muted small fw-bold mt-1 mb-0" style={{ fontSize: "clamp(11px, 1.2vw, 14px)" }}>{c.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BuyerOverview;